import { render } from "./NewDonorVitalsForm.vue?vue&type=template&id=0f0f9a46&scoped=true"
import script from "./NewDonorVitalsForm.vue?vue&type=script&lang=js"
export * from "./NewDonorVitalsForm.vue?vue&type=script&lang=js"

import "./NewDonorVitalsForm.vue?vue&type=style&index=0&id=0f0f9a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0f9a46"]])

export default __exports__